import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { signUpStorageKey, SignUpCompartments } from '../index';

export class AllOrgSignUpStatesListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.TeamSelected) private readonly predicate: Observable<boolean>,
    @injectDataCache(signUpStorageKey) private readonly cache: DataCache<SignUpCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('allOrgSignUpStates');
        } else {
          this.cache.reset('allOrgSignUpStates');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class OnboardingTemplateListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.IsAuthenticated) private readonly predicate: Observable<boolean>,
    @injectDataCache(signUpStorageKey) private readonly cache: DataCache<SignUpCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('onboardingTemplate');
        } else {
          this.cache.reset('onboardingTemplate');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class OrgSignUpStateListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.IsAuthenticated) private readonly predicate: Observable<boolean>,
    @injectDataCache(signUpStorageKey) private readonly cache: DataCache<SignUpCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('orgSignUpState');
        } else {
          this.cache.reset('orgSignUpState');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
